(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-customisation"] && !Shopify.designMode) return;
  try {
    (function () {
    var selects = document.querySelectorAll('.custom-select');

    function closeSelect(select) {
      select.classList.remove('is-open');
      select.querySelector('.custom-select__trigger').setAttribute('aria-expanded', 'false');
    }

    function closeAllSelects(except) {
      selects.forEach(function (select) {
        if (select !== except) closeSelect(select);
      });
    }

    function setValue(select, option, dispatch) {
      var valueEl = select.querySelector('.custom-select__value');
      var hiddenInput = select.querySelector('input[type="hidden"]');
      var options = select.querySelectorAll('.custom-select__option');

      options.forEach(function (opt) {
        opt.classList.remove('is-selected');
        opt.setAttribute('aria-selected', 'false');
      });

      option.classList.add('is-selected');
      option.setAttribute('aria-selected', 'true');
      valueEl.textContent = option.textContent.trim();
      hiddenInput.value = option.getAttribute('data-value');

      if (dispatch !== false) {
        select.dispatchEvent(
          new CustomEvent('customselect:change', {
            bubbles: true,
            detail: { value: hiddenInput.value, option: option },
          })
        );
      }
    }

    selects.forEach(function (select) {
      var trigger = select.querySelector('.custom-select__trigger');
      var menu = select.querySelector('.custom-select__menu');
      var options = select.querySelectorAll('.custom-select__option');

      trigger.addEventListener('click', function () {
        var isOpen = select.classList.contains('is-open');
        closeAllSelects(select);
        select.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          if (option.hidden) return;
          setValue(select, option);
          closeSelect(select);
          trigger.focus();
        });
      });

      select.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeSelect(select);
          trigger.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.custom-select')) {
        closeAllSelects();
      }
    });

    // --- Pets / scene filtering logic (adapted to custom selects) ---
    var petsSelect = document.getElementById('NumberOfPets');
    var sceneSelect = document.getElementById('SceneSelect');
    var textInput = document.getElementById('CustomText');
    var counter = document.getElementById('CustomTextCounter');

    if (petsSelect && sceneSelect) {
      petsSelect.addEventListener('customselect:change', function (e) {
        var pets = parseInt(e.detail.value || '1', 10);
        var sceneOptions = sceneSelect.querySelectorAll('.custom-select__option');
        var firstVisible = null;

        sceneOptions.forEach(function (option) {
          var maxPets = parseInt(option.getAttribute('data-max-pets') || '2', 10);
          var shouldHide = pets > maxPets;
          option.hidden = shouldHide;
          if (!shouldHide && !firstVisible) firstVisible = option;
        });

        var selected = sceneSelect.querySelector('.custom-select__option.is-selected');
        if (selected && selected.hidden && firstVisible) {
          setValue(sceneSelect, firstVisible, false);
        }
      });
    }

    if (textInput && counter) {
      var max = textInput.maxLength || 15;
      function updateCounter() {
        var remaining = max - textInput.value.length;
        counter.textContent = remaining + ' / ' + max;
      }
      textInput.addEventListener('input', updateCounter);
      updateCounter();
    }

    var fileDrops = document.querySelectorAll('[id^="CustomPhotoDrop-"]');

    fileDrops.forEach(function (fileDrop) {
      var dropIndex = fileDrop.id.split('-')[1];
      var fileInput = document.getElementById('CustomPhoto-' + dropIndex);

      if (fileDrop && fileInput) {
        var dragCounter = 0;
        var MAX_FILES = 5;
        var MAX_FILE_SIZE = 10 * 1024 * 1024;

        function validateFiles(files) {
          var validFiles = [];
          var errors = [];

          if (files.length > MAX_FILES) {
            errors.push('Maximum ' + MAX_FILES + ' files allowed');
            return { valid: [], errors: errors };
          }

          Array.from(files).forEach(function (file) {
            if (file.size > MAX_FILE_SIZE) {
              errors.push(file.name + ' exceeds 10MB limit');
            } else {
              validFiles.push(file);
            }
          });

          return { valid: validFiles, errors: errors };
        }

        function showFileName() {
          var filenamesContainer = document.getElementById('CustomPhotoFilenames-' + dropIndex);
          if (fileInput.files && fileInput.files.length) {
            filenamesContainer.innerHTML = '';
            Array.from(fileInput.files).forEach(function (file) {
              var div = document.createElement('div');
              div.className = 'file-drop__filename-item';
              div.textContent = file.name + ' (' + (file.size / 1024 / 1024).toFixed(2) + ' MB)';
              filenamesContainer.appendChild(div);
            });
            fileDrop.classList.add('has-file');
          } else {
            filenamesContainer.innerHTML = '';
            fileDrop.classList.remove('has-file');
          }
        }

        fileInput.addEventListener('change', function (e) {
          var result = validateFiles(e.target.files);
          if (result.errors.length) {
            alert(result.errors.join('\n'));
            fileInput.value = '';
            showFileName();
          } else {
            showFileName();
          }
        });

        fileDrop.addEventListener('drop', function (e) {
          dragCounter = 0;
          fileDrop.classList.remove('is-dragover');
          var files = e.dataTransfer && e.dataTransfer.files;
          if (files && files.length) {
            var result = validateFiles(files);
            if (result.errors.length) {
              alert(result.errors.join('\n'));
            } else {
              fileInput.files = files;
              showFileName();
            }
          }
        });

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (evt) {
          fileDrop.addEventListener(evt, function (e) {
            e.preventDefault();
            e.stopPropagation();
          });
        });

        fileDrop.addEventListener('dragenter', function () {
          dragCounter++;
          fileDrop.classList.add('is-dragover');
        });

        fileDrop.addEventListener('dragleave', function () {
          dragCounter--;
          if (dragCounter <= 0) {
            dragCounter = 0;
            fileDrop.classList.remove('is-dragover');
          }
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
